import styled from "styled-components";
import colors from "../../themes/colors.theme";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: ${colors.light};
`

export default Container;